module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var columns = widget.gridColumns() 
    ; __append("\n")
    ;  var actions = widget.gridActions() 
    ; __append("\n<div class=\"relative grid-view\">\n    <div class=\"count\">\n        Всего: <span name=\"gridview-count\">")
    ; __append(escapeFn( widget.gridCount ))
    ; __append("</span>\n    </div>\n	<div class=\"gridview table wh100\">\n		")
    ;  if (widget.showHeader) { 
    ; __append("\n		<div>\n			<div class=\"gridview__header\">\n				<table class=\"gridview__table\" name=\"gridview-header\">\n					<colgroup>\n						")
    ;  Util.each(columns, function (column) { 
    ; __append("\n							<col width=\"")
    ; __append(escapeFn( column.width ? column.width : "*" ))
    ; __append("\">\n						")
    ;  }) 
    ; __append("\n						")
    ;  Util.each(actions, function (action) {
							if (!Util.isDefined(action.enabled) || (Util.isDefined(action.enabled) && (Util.isFunction(action.enabled) || !!action.enabled))) { 
    ; __append("\n								<col width=\"")
    ; __append(escapeFn( action.width ? action.width : "*" ))
    ; __append("\">\n							")
    ;  }
						}) 
    ; __append("\n					</colgroup>\n					<tbody>\n					<tr>\n						")
    ;  Util.each(columns, function (column) { 
    ; __append("\n						<td>\n							")
    ;  if (column.sorted) { 
    ; __append("\n								<a class=\"button_sort\" href=\"javascript:void(0)\" on-click=\"onSortClick\"\n								   data-is-sorted=\"")
    ; __append(escapeFn( column.sorted ))
    ; __append("\"\n								   name=\"")
    ; __append(escapeFn( column.name ))
    ; __append("\">")
    ; __append(escapeFn( column.title ))
    ; __append("\n									<i class=\"icon-sort-amount-asc icon_asc\"></i>\n									<i class=\"icon-sort-amount-desc icon_desc\"></i>\n								</a>\n							")
    ;  } else { 
    ; __append("\n								")
    ; __append(escapeFn( column.title ))
    ; __append("\n							")
    ;  } 
    ; __append("\n						</td>\n						")
    ;  }) 
    ; __append("\n						")
    ;  Util.each(actions, function (action) {
							if (!Util.isDefined(action.enabled) || (Util.isDefined(action.enabled) && (Util.isFunction(action.enabled) || !!action.enabled))) { 
    ; __append("\n								<td></td>\n							")
    ;  }
						}) 
    ; __append("\n					</tr>\n					</tbody>\n				</table>\n			</div>\n		</div>\n		")
    ;  } 
    ; __append("\n\n		<div>\n			<div class=\"gridview__body\">\n				<div>\n					<div>\n						<table class=\"gridview__table\" name=\"gridview-body\">\n							<colgroup>\n								")
    ;  let columnCount = 0 
    ; __append("\n								")
    ;  Util.each(columns, function (column) { columnCount++;
    ; __append("\n									<col width=\"")
    ; __append(escapeFn( column.width ? column.width : "*" ))
    ; __append("\">\n								")
    ;  }) 
    ; __append("\n								")
    ;  Util.each(actions, function (action) {
									if (!Util.isDefined(action.enabled) || (Util.isDefined(action.enabled) && (Util.isFunction(action.enabled) || !!action.enabled))) {
										columnCount++;
    ; __append("\n										<col width=\"")
    ; __append(escapeFn( action.width ? action.width : "*" ))
    ; __append("\">\n									")
    ;  }
								}) 
    ; __append("\n							</colgroup>\n							<tbody name=\"list-items\">\n								<tr class=\"no-items\"><td colspan=\"")
    ; __append(escapeFn( columnCount ))
    ; __append("\" style=\"text-align: center;\">Список пуст</td></tr>\n							</tbody>\n						</table>\n					</div>\n				</div>\n			</div>\n		</div>\n\n		")
    ;  if (widget.showFooter) { 
    ; __append("\n		<div>\n			<div class=\"gridview__footer split cell__middle\" name=\"gridview-footer\"></div>\n		</div>\n		")
    ;  } 
    ; __append("\n\n	</div>\n	<div name=\"loader\" class=\"gridview__loader\"></div>\n</div>\n")
  }
  return __output.join("");

}